import moment from 'moment';

// eslint-disable-next-line import/prefer-default-export
export const getDateNaissanceInconnueFRFromYYYYMMDD = (stringDate = '') => {
    const dateArray = stringDate.split('-');
    let day = dateArray[2];
    let month = dateArray[1];
    const year = dateArray[0];

    if (!day) {
        day = '00';
    }

    if (!month) {
        month = '00';
    }
    return `${day}/${month}/${year}`;
};

export const getDateNaissanceISOFromFR = (stringDate = '') => {
    let dateNaissanceFormate;
    if (stringDate.indexOf('/') > 0 || stringDate.length === 4) {
        const dateNaissance = stringDate.split('/');
        if (dateNaissance.length > 2) {
            // Si jour/mois/année
            dateNaissanceFormate = `${dateNaissance[2]}-${dateNaissance[1]}-${dateNaissance[0]}`;
        } else if (dateNaissance.length === 2) {
            // Si mois/année ou jour/mois
            dateNaissanceFormate = `${dateNaissance[1]}-${dateNaissance[0]}`;
        } else {
            // Si il n'y a que l'année
            dateNaissanceFormate = `${dateNaissance[0]}`;
        }
    } else {
        const dateNaissance = stringDate.split('-');

        dateNaissanceFormate = `${dateNaissance[2]}-${dateNaissance[1]}-${dateNaissance[0]}`;
    }

    return dateNaissanceFormate;
};

export const getDateFRFromYYYYMMDDHHMMSS = (stringDate = '') =>
    moment(stringDate, 'YYYY-MM-DD hh:mm:ss').format('DD/MM/YYYY');
